const article = {
  "article.title": "Basetao Spreadsheet Guide: What It Is & How to Use It",
  "article.meta.description":
    "Learn what a Basetao Spreadsheet is, what you will find inside it, and how to use it to compare products, sellers and categories when ordering through Basetao.",
  "article.breadcrumb": "Spreadsheet Guide",
  "article.h1": "Basetao Spreadsheet Guide: What It Is & How to Use It",

  "article.author": "By:",
  "article.author.name": "Basetao Sheet Editorial Team",
  "article.published": "Published:",
  "article.updated": "Updated:",
  "article.date": "August 18, 2026",

  "article.intro":
    "A Basetao Spreadsheet is a shared, organized list of product links, categories, sellers and notes that shoppers use to find and compare items ordered through Basetao. In short, it turns a large, scattered catalog into a tidy starting point you can filter, sort and share. This guide explains what is typically inside one, how to read it and how to use it to shop more efficiently.",

  "article.toc.title": "On this page",
  "article.toc.1": "What is a Basetao Spreadsheet?",
  "article.toc.2": "What you will find inside",
  "article.toc.3": "How to use a Basetao Spreadsheet",
  "article.toc.4": "Why shoppers rely on a spreadsheet",
  "article.toc.5": "Tips for getting the most out of it",
  "article.toc.6": "Frequently asked questions",

  "article.s1.h2": "What Is a Basetao Spreadsheet?",
  "article.s1.p1":
    "Basetao is a shopping agent that helps buyers outside China order from marketplaces such as Taobao, Weidian and 1688, then ship those items internationally. A Basetao Spreadsheet is a companion resource: a list that someone has already built and shared, containing links to specific products, their categories, sellers and helpful notes.",
  "article.s1.p2":
    "Think of it as a curated map of the catalog rather than the catalog itself. Instead of searching hundreds of pages, you begin from a set of items that other buyers have already located and, in many cases, checked. That saves time and gives you a more focused way to compare your options.",

  "article.s2.h2": "What You Will Find Inside a Basetao Spreadsheet",
  "article.s2.p1":
    "Spreadsheets vary, but most well-made ones are built around a few consistent columns. Here is what each column usually means and why it helps.",
  "article.s2.table.c1": "Column",
  "article.s2.table.c2": "What it shows",
  "article.s2.table.c3": "Why it helps",
  "article.s2.r1.c1": "Product",
  "article.s2.r1.c2": "The specific item and its link",
  "article.s2.r1.c3": "Jump straight to the item you want",
  "article.s2.r2.c1": "Category",
  "article.s2.r2.c2": "Which group the item belongs to",
  "article.s2.r2.c3": "Filter shoes, hoodies, bags and more",
  "article.s2.r3.c1": "Seller",
  "article.s2.r3.c2": "The shop or seller name",
  "article.s2.r3.c3": "Spot reliable sellers you recognize",
  "article.s2.r4.c1": "Notes / QC",
  "article.s2.r4.c2": "Quality-check and other remarks",
  "article.s2.r4.c3": "Avoid issues before you order",

  "article.s3.h2": "How to Use a Basetao Spreadsheet",
  "article.s3.p1":
    "You do not need any special tools to use a spreadsheet. Follow these four steps to go from a list to a confident order.",
  "article.s3.step1.title": "1. Start with a category",
  "article.s3.step1.text":
    "Filter the sheet by the category you care about — shoes, t-shirts, jackets, bags or accessories — so you only look at relevant rows.",
  "article.s3.step2.title": "2. Check the notes",
  "article.s3.step2.text":
    "Read any seller and quality-check notes attached to a product. These remarks often highlight sizing, quality or shipping details.",
  "article.s3.step3.title": "3. Open the product link",
  "article.s3.step3.text":
    "Use the product link to view the item on the main site and confirm the price, photos and availability before you commit.",
  "article.s3.step4.title": "4. Compare before you buy",
  "article.s3.step4.text":
    "Put two or three similar items side by side to compare sellers and details, then choose the one that best fits your needs.",

  "article.s4.h2": "Why Shoppers Rely on a Spreadsheet",
  "article.s4.p1":
    "The main reason is simple: a spreadsheet removes most of the browsing friction. Instead of opening page after page and trying to remember what you saw, you get a single, sortable view of products, categories, sellers and notes. It is especially useful when you are new to using a shopping agent, because the list gives you a starting point that is already organized, and the notes can help you avoid common mistakes such as overlooking sizing or choosing an unreliable seller.",

  "article.s5.h2": "Tips for Getting the Most Out of It",
  "article.s5.p1": "Keep these habits in mind to make the spreadsheet work harder for you.",
  "article.s5.t1": "Verify before ordering — links and prices can change, so always confirm the item on the product page.",
  "article.s5.t2": "Use the categories to narrow your search instead of scrolling the whole list.",
  "article.s5.t3": "Add your own notes as you compare so your shortlist stays organized.",
  "article.s5.t4": "Bookmark the items you like so you can come back to them later.",

  "article.s6.h2": "Frequently Asked Questions",
  "article.s6.q1": "Do I need a Basetao account to use the spreadsheet?",
  "article.s6.a1":
    "No. You can read and use the spreadsheet freely. You only need an account if you decide to order through a shopping agent or the main site.",
  "article.s6.q2": "Are the products in the spreadsheet always available?",
  "article.s6.a2":
    "Availability, prices and seller details can change over time. The spreadsheet is a helpful starting point, but you should always confirm the current details on the product page.",

  "article.s7.h2": "Final Thoughts",
  "article.s7.p1":
    "A Basetao Spreadsheet is one of the simplest ways to shop through a shopping agent without starting from zero. By giving you a structured list of products, categories, sellers and notes, it helps you save time, compare more easily and make more confident choices. Start from a category, check the notes and verify the product page before you buy.",

  "article.cta.text": "Ready to start browsing? Explore the full catalog on the main site.",
  "article.cta.button": "Buy It Now",
  "article.backHome": "Back to home",
};

export default article;